import { createStructuredSelector } from "reselect";
import {
    PI_PRODUCT,
    PI_PRODUCT_SUCCESS,
    PI_PRODUCT_ERROR,
    PI_ATC_LIST,
    PI_ATC_LIST_SUCCESS,
    PI_ATC_LIST_ERROR,
    PI_ATC,
    PI_ATC_SUCCESS,
    PI_ATC_ERROR,
    PI_PHARMACEUTICAL_FORM,
    PI_PHARMACEUTICAL_FORM_SUCCESS,
    PI_PHARMACEUTICAL_FORM_ERROR,
    PI_PRESENTATION,
    PI_PRESENTATION_SUCCESS,
    PI_PRESENTATION_ERROR,
    PI_LIST,
    PI_LIST_SUCCESS,
    PI_LIST_ERROR,
    PI_LIST_SEARCH_CHANGE,
    PI_LIST_PAGE_SET,
    PI_EDIT_MODAL_SET,
    PI_EDIT_CHANGE_SET,
    PI_EDIT,
    PI_EDIT_SUCCESS,
    PI_EDIT_ERROR,
} from "../../actions";

export const NAME = 'productInfo';

export const PIProduct = (data) => ({
    type: PI_PRODUCT,
    payload: data
});

export const PIProductSuccess = (data) => ({
    type: PI_PRODUCT_SUCCESS,
    payload: data
});

export const PIProductError = (error) => ({
    type: PI_PRODUCT_ERROR,
    payload: error
});

export const PIAtcList = (data) => ({
    type: PI_ATC_LIST,
    payload: data
});

export const PIAtcListSuccess = (data) => ({
    type: PI_ATC_LIST_SUCCESS,
    payload: data
});

export const PIAtcListError = (error) => ({
    type: PI_ATC_LIST_ERROR,
    payload: error
});

export const PIAtc = (data) => ({
    type: PI_ATC,
    payload: data
});

export const PIAtcSuccess = (data) => ({
    type: PI_ATC_SUCCESS,
    payload: data
});

export const PIAtcError = (error) => ({
    type: PI_ATC_ERROR,
    payload: error
});

export const PIPharmaceuticalForm = (data) => ({
    type: PI_PHARMACEUTICAL_FORM,
    payload: data
});

export const PIPharmaceuticalFormSuccess = (data) => ({
    type: PI_PHARMACEUTICAL_FORM_SUCCESS,
    payload: data
});

export const PIPharmaceuticalFormError = (error) => ({
    type: PI_PHARMACEUTICAL_FORM_ERROR,
    payload: error
});

export const PIPresentation = (data) => ({
    type: PI_PRESENTATION,
    payload: data
});

export const PIPresentationSuccess = (data) => ({
    type: PI_PRESENTATION_SUCCESS,
    payload: data
});

export const PIPresentationError = (error) => ({
    type: PI_PRESENTATION_ERROR,
    payload: error
});

export const PIList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: PI_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const PIListSuccess = (data) => ({
    type: PI_LIST_SUCCESS,
    payload: data
});

export const PIListError = (error) => ({
    type: PI_LIST_ERROR,
    payload: error
});

export const PIPageSet = (data) => ({
    type: PI_LIST_PAGE_SET,
    payload: data
});

export const PISearchChange = (data) => ({
    type: PI_LIST_SEARCH_CHANGE,
    payload: data
});


export const PIEditModalSet = (data) => ({
    type: PI_EDIT_MODAL_SET,
    payload: data
});

export const PIEditChangeSet = (data) => ({
    type: PI_EDIT_CHANGE_SET,
    payload: data
});

export const PIEdit = (page, num_page, orderBy, filters, data) => ({
    type: PI_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const PIEditSuccess = (message) => ({
    type: PI_EDIT_SUCCESS,
    payload: message
});

export const PIEditError = (error) => ({
    type: PI_EDIT_ERROR,
    payload: error
});

const productInfo = (state) => state[NAME];

export const ProductInfoSelector = createStructuredSelector({
    productInfo
})